import ReportList from './container/index';

export default ReportList;



// WEBPACK FOOTER //
// ./src/views/ReportList/index.js